import React, { useCallback } from 'react';
import { scrollIntoViewIfNeeded } from '../../../lib/scrollIntoViewIfNeeded';
import {
  useUpdateCartMutation,
  useCart,
  CartUpdatePropertyName,
  CartUpdateAction
} from '../../../hooks/useCart';
import { RestAddress } from '../../../hooks/useAddress';
import { useCheckoutStepTracking, CheckoutStep } from '../../../hooks/useCheckout';
import { CheckoutSection } from '../../CheckoutSection';
import { ShippingAddressSelector, Mode } from '../ShippingAddressSelector';

export const CheckoutShippingAddress: React.FC = () => {
  const { cart } = useCart();
  const [updateCart] = useUpdateCartMutation();
  const { trackCheckoutStepView, trackCheckoutStepComplete } = useCheckoutStepTracking(
    CheckoutStep.ShippingAddress
  );

  const defaultAddressId = cart.attributes.addressId?.toString();

  const onSubmit = useCallback(
    async (address: RestAddress) => {
      await updateCart(CartUpdateAction.ShippingAddress, {
        [CartUpdatePropertyName.ShippingAddress]: address.id
      });
      trackCheckoutStepComplete();
    },
    [updateCart, trackCheckoutStepComplete]
  );

  const onModeChange = useCallback(
    (previousMode: Mode | undefined, nextMode: Mode) => {
      if (nextMode !== Mode.Resting && (previousMode == null || previousMode === Mode.Resting)) {
        trackCheckoutStepView();
      }
      if (nextMode !== Mode.Saving) {
        scrollIntoViewIfNeeded(document.getElementById('shipping_address'));
      }
    },
    [trackCheckoutStepView]
  );

  return (
    <CheckoutSection id="shipping_address" title="Shipping Address">
      <ShippingAddressSelector
        source="moda"
        defaultAddressId={defaultAddressId}
        onModeChange={onModeChange}
        onSubmit={onSubmit}
      />
    </CheckoutSection>
  );
};
